import { sendFormC57Service } from '../services'

export default (id, sendFormComment) => {
  return new Promise(async (resolve, reject) => {
    await sendFormC57Service.sendFormC57(id, sendFormComment)
      .then(response => resolve(response.data))
      .catch(err => reject({ error: true }))
  })
}
